import React from 'react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Row } from '@cuemath/comps';
import { FORM_ACTIONS } from 'constants/form';
import { IconButton } from 'modules/list';
import ViewIcon from 'img/view.png';
import { epochToDate, epochTo24HrTime } from 'utils';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding-left: 20px;
  padding-right: 20px;
`;

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  &:hover {
    color: blue;
  }
  &:active {
    color: blue;
  }
`;

const DEFAULT = { DATE_FORMAT: 'DD-MM-YYYY' };

const ApplicantsTable = ({ applicants, onPageChange }) => {
  const convertDateToformat = epochtime => {
    const date = epochToDate(epochtime, DEFAULT.DATE_FORMAT);
    const time = epochTo24HrTime(epochtime);
    const format = `${date} ${time}`;
    return format;
  };

  const tableColumns = [
    {
      columns: [
        {
          Header: '',
          accessor: 'name',
          Cell: row => {
            return (
              <Row justifyContent="space-around">
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/teacher-applicants/${row.original.id}`,
                    state: {
                      formType: FORM_ACTIONS.CREATE,
                      teacher: row.original,
                    },
                  }}
                >
                  <IconButton icon={ViewIcon} onClick={() => {}} />
                </LinkNav>
              </Row>
            );
          },
        },
        {
          Header: 'Name',
          accessor: 'name',
          width: 200,
          Cell: row => {
            return (
              <LinkNav
                target="_blank"
                to={{
                  pathname: `/teacher-applicants/${row.original.id}`,
                  state: {
                    formType: FORM_ACTIONS.CREATE,
                    teacher: row.original,
                  },
                }}
              >
                {row.original.name}
              </LinkNav>
            );
          },
        },
        {
          Header: 'Phone',
          accessor: 'phone',
          width: 200,
          Cell: row => {
            return <div>{row.original.phone}</div>;
          },
        },
        {
          Header: 'Email',
          accessor: 'email',
          width: 200,
          Cell: row => {
            return <div>{row.original.email}</div>;
          },
        },
        {
          Header: 'Created On',
          accessor: 'created_on',
          width: 200,
          Cell: row => {
            return <div>{convertDateToformat(row.original.created_on)}</div>;
          },
        },
        {
          Header: 'State',
          accessor: 'state',
          width: 200,
          Cell: row => {
            return <div>{row.original.state}</div>;
          },
        },
      ],
    },
  ];

  return (
    <>
      <TableWrapper>
        <ReactTable
          data={applicants}
          className="-striped -highlight"
          manual
          showPageSizeOptions={false}
          filterable={false}
          sortable={false}
          resizable={false}
          defaultPageSize={20}
          onPageChange={onPageChange}
          columns={tableColumns}
          style={{ textAlign: 'center' }}
        />
      </TableWrapper>
    </>
  );
};

export default ApplicantsTable;
